import axios from '@/components/api/axios';

async function getStamp(bcNo) {
  let data = {
    bcNo: bcNo
  }
  console.log(data);
  const res = await axios.axiosGet('/api/plusone/get_stamp', data);
  return res;
}

async function getAllPresents(bcNo) {
  let data = {
    bcNo: bcNo
  }
  const res = await axios.axiosGet('/api/plusone/get_all_presents', data);
  return res;
}

async function registSelectPresentInfo(bcNo, giftProductId) {
  let data = {
    bcNo: bcNo,
    giftProductId: giftProductId
  }
  console.log(data);
  const res = await axios.axiosPost('/api/plusone/regist_select_present_info', data);
  return res;
}


export default {
  getStamp,
  getAllPresents,
  registSelectPresentInfo
}



// WEBPACK FOOTER //
// ./src/components/api/plusone/index.js